import { HoverCard, MantineThemeOverride, NativeSelect } from '@mantine/core';

export const getCustomeThemeOverrides = (): MantineThemeOverride => ({
    components: {
        NativeSelect: NativeSelect.extend({
            defaultProps: {
                unstyled: true,
            },
            classNames: {
                root: 'select-container',
                label: 'select-label',
                wrapper: 'select-wrapper',
                input: 'select',
            },
        }),
        HoverCard: HoverCard.extend({
            classNames: {
                dropdown: 'absolute card',
            },
        }),
    },
});
